export default "__VITE_ASSET__G5ed7hq0__"